module.exports = __webpack_public_path__ + "static/media/exchange.80dfa5b5.svg";